<template>
  <div :showIfHasPermission="['rms.code_developer']">
  <div v-if="showComponent && onReady" :key="componentRefresh">
    <div class="input-group" v-if="showMenu">
      <button
          v-if="buttonDropdown"
          :class="screenSizeId >= 4 ? 'btn btn-outline-secondary dropdown-toggle dropdown-toggle-mode' : 'btn btn-link p-1 m-1'"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          :style="[{'min-width': screenSizeId >= 4 ? '150px' : '' }]"
      >
        <span>
          <i v-if="l_selectedMode.id" :class="l_selectedMode.icon"/>
          <i v-else class="fas fa-chevron-down"></i>
          <ks-space v-if="screenSizeId >= 4"/>
          <span v-if="screenSizeId >= 4">
            <span v-if="l_selectedMode.id">{{ l_selectedMode.mode_name }}</span>
            <span v-else style="font-style: italic;">No Mode</span>
          </span>
        </span>
      </button>
      <div :class="`dropdown-menu${screenSizeId < 3 ? ' dropdown-menu-right' : ''}`" style="min-width: 150px;">
        <div
            v-for="dataMode in modes"
            :class="[{
            'dropdown-item': true,
            'active': l_selectedMode.id === dataMode.id
          }]"
            @click.prevent="modeSelected(dataMode)"
        >
          <ks-flex wrap="nowrap" :class="{'pl-3': dataMode.parent_data_provider_mode_id}">
            <i :class="dataMode.icon" v-if="dataMode.icon"/>
            <ks-space v-if="dataMode.icon"/>
            {{ dataMode.mode_name }}
          </ks-flex>
        </div>
      </div>
      <select
          v-if="!buttonDropdown"
          class="custom-select"
          v-model="l_selectedMode"
          @change="data_provider_ref.selectModeByName(l_selectedMode.mode_name, true)"
      >
        <option v-for="(dataMode, index) in modes" :value="dataMode">{{ dataMode.mode_name }}</option>
      </select>
      <template v-if="enableActions">
        <ks-block class="input-group-append" v-show="l_selectedMode.id" :showIfHasPermission="['rms.code_developer']">
          <button
              class="btn btn-primary btn-sm"
              type="button"
              @click.prevent="openModeModal('edit')"
          >
            <i class="fas fa-edit"/>
          </button>
        </ks-block>
        <div class="input-group-prepend">
          <button
              class="btn btn-outline-success btn-sm"
              type="button"
              @click="openModeModal('new')"
          >
            <i class="fas fa-plus"/>
          </button>
        </div>
      </template>
    </div>
    <div style="text-transform: capitalize; margin-left: 6px;" v-if="showButtons && screenSizeId >= 4">
      <template v-for="dataMode in modes">
        <a v-if="dataMode.icon && dataMode.display_quick_icon === 1"
           class="btn btn"
           :class="[{'active-mode': l_selectedMode ? dataMode.id === l_selectedMode.id : false}]"
           data-toggle="tooltip" data-placement="top" :title="dataMode.mode_name"
           @click.prevent="data_provider_ref.selectModeByName(dataMode.mode_name, true)" style="position: relative;">
          <i :class="dataMode.icon"></i>
          <span class="modebadge" v-if="getFacet(dataMode.mode_name)">{{getFacet(dataMode.mode_name).facet_count}}</span>
        </a>
      </template>
    </div>
  </div>
  </div>
</template>


<script>
import checkPermissions from '../../mixins/checkPermissions';
import onMountedDataProvider from '../../mixins/onMountedDataProvider';
import _ from 'lodash'
import Vuex from 'vuex'

export default {
  name: "ks-mode-selector",
  mixins: [checkPermissions, onMountedDataProvider],
  props: {
    dataProvider: {type: String, required: true},
    buttonDropdown: {type: Boolean, default: false},
    enableActions: {type: Boolean, default: false},
    showMenu: {type: Boolean, default: true},
    showButtons: {type: Boolean, default: false},
  },
  watch: {
    selectedMode: {
      handler: function (val) {
        this.l_selectedMode = JSON.parse(JSON.stringify(this.selectedMode));
      },
      deep: true
    }
  },
  computed: {
    facets: {
      get: () => {
        return app.store.state.ks_app.global_data.facets;
      },
      set: (value) => {
        app.store.commit('ks_app/global_data/setFacets', value);
      }
    },
    ...Vuex.mapGetters({auth: 'rms_ui/auth/auth'}),
    modes() {
      return this.data_provider_ref.modes;
    },
    selectedMode() {
      return this.data_provider_ref.selectedMode;
    },
    isAdminUser() {
      return app.auth.user.id === 1;
    },
    screenSizeId() {
      return app.layout.screenSizeId;
    }
  },
  methods: {
    getFacet(data_mode_name) {
      let found = this.facets.find(facet => facet.data_mode_name === data_mode_name);
      if (found) {
        return found;
      } else {
        return null;
      }
    },
    modeSelected(dataMode) {
      this.data_provider_ref.selectModeByName(dataMode.mode_name, true);
      this.$emit('onModeChange');
    },
    async openModeModal(type) {
      this.data_provider_ref.openModeModal(type);
    }
  },
  async mounted() {
    await this.onMountedDataProvider();
    this.l_selectedMode = JSON.parse(JSON.stringify(this.selectedMode));
  },
  data() {
    return {
      l_selectedMode: {},
      facetCountList: [
        {
          'data_mode_name': null,
          'facet_name': null,
          'facet_count': null,
        }
      ],
    }
  }
}
</script>

<style>
.active-mode {
  background-color: #dddddd;
}

.dropdown-toggle-mode::after {
  float: right !important;
  margin-top: 8px !important;
}
.modebadge {
  position: absolute;
  top: 5px;
  right: 6px;
  border-radius: 70%;
  background: red;
  color: white;
  font-size: 9px;
  padding: 0 1px 0 1px;
  min-width: 13px;
}
</style>
